import { useMediaQuery } from '@mui/material';

/**
 * Ancho mínimo de la banda “referencia” (diseño tipo iPad Pro).
 * 834px ≈ iPad Pro 11" vertical; el grid de 3 columnas sigue usando MUI `md` (900px).
 */
export const NEW_DASHBOARD_REF_MIN_PX = 834;
/** iPad Pro 12.9" landscape y equivalentes; por encima se considera pantalla grande. */
export const NEW_DASHBOARD_REF_MAX_PX = 1366;

/**
 * Bandas para la New Dashboard View:
 * - reference: mismo diseño “actual” pensado para iPad Pro (~900–1366px).
 * - compact: más chico (teléfonos, tablets estrechas).
 * - expanded: monitores grandes; escala tipografía y áreas útiles.
 */
export function useNewDashboardLayout() {
  const isCompact = useMediaQuery(`(max-width:${NEW_DASHBOARD_REF_MIN_PX - 1}px)`);
  const isExpanded = useMediaQuery(`(min-width:${NEW_DASHBOARD_REF_MAX_PX + 1}px)`);

  const band = isCompact ? 'compact' : isExpanded ? 'expanded' : 'reference';

  return {
    band,
    isCompact,
    isExpanded,
    isReference: band === 'reference',
  };
}
